module.exports = __webpack_public_path__ + "img/itinerary_mobile.eb410a67.png";